import { getEntities, getEntity, isCreating, getCreateError } from './_utils'

// getters
export const getBankAccounts = getEntities('bankAccounts')
export const getBankAccount = getEntity('bankAccounts')

// notifiers
export const creatingBankAccount = isCreating('/users/profile/banks')
export const getCreateBankAccountError = getCreateError('/users/profile/banks')
